import * as React from "react";
import {Buttons} from "../../../../components/buttons/Buttons";
import "./HaccpTableRow.scss";

export class HaccpEquipmentRow {
    public static renderEquipmentRow = (
        equipment,
        onExport,
        showExtremes: boolean,
        rowKey?,
        hasConfigured?: boolean,
        missingHaccpConfigs?: boolean,
    ) => {
        return (
            <tr className={"HaccpTableRow"} key={rowKey} style={{height: "50px"}}>
                <td
                    className={"sticky-td"}
                    colSpan={0}
                    style={{
                        height: "50px",
                        width: missingHaccpConfigs ? "350px" : null,
                    }}
                >
                    <div className={"cell-content-wrapper"}>
                        <div className={"vertical-align"}>
                            <div className={"vertical-align"}>
                                <div className="locationEquipmentImage">
                                    <img
                                        src={equipment.model.typeImage}
                                        style={{width: "35px", height: "35px", paddingRight: "10px"}}
                                    />
                                </div>
                                <div
                                    className={"diagnostics-name"}
                                    style={{
                                        width: "215px",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <span style={{fontWeight: "bold"}}>{
                                        (equipment.name)
                                            ? equipment.name
                                            : (equipment.customerCode
                                                    ? equipment.customerCode.code
                                                    : (equipment.manufacturerCode
                                                            ? equipment.manufacturerCode.code
                                                            : "N/A"
                                                    )
                                            )
                                    }</span>
                                    <p>{equipment.model.name}</p>

                                </div>
                                <div className="actions">
                                    <div style={{display: "inline-block", marginRight: "10px"}}>
                                        <div className="button-export-to-excel">
                                            {
                                                hasConfigured ? (<Buttons.ButtonWithIcon
                                                        key={13}
                                                        code={"excel"}
                                                        icon={"images/buttons/icon-excelLogo.png"}
                                                        selected={false}
                                                        onClick={
                                                            // tslint:disable-next-line:jsx-no-lambda
                                                            () => onExport(equipment.guid)
                                                        }
                                                    />)
                                                    : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td
                    className="lo-col"
                    style={{
                        height: "50px",
                        borderRight: "none",
                        width: missingHaccpConfigs ? "50px" : null,
                    }}
                >
                    <div
                        className="cell-content-wrapper"
                        style={{
                            borderRight: "none",
                        }}
                    >
                        <div className="vertical-align"/>
                    </div>
                </td>
                <td
                    className="hi-col"
                    style={{
                        height: "50px",
                        width: missingHaccpConfigs ? "50px" : null,
                    }}
                >
                    <div
                        className="cell-content-wrapper"
                        style={
                            {
                                borderRight: (showExtremes) ? "none" : "2px solid gainsboro",
                                boxShadow: (showExtremes) ? null : "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                            }
                        }
                    >
                        <div className="vertical-align"/>
                    </div>
                </td>
                {showExtremes
                    ? (
                        <td className={"def-col"} style={{height: "unset"}}>
                            <div
                                className={"cell-content-wrapper"}
                                style={{
                                    height: "50px",
                                    borderRight: (showExtremes) ? "2px solid gainsboro" : "none",
                                    boxShadow: (showExtremes) ? "6px 0px 6px 0px rgb(0 0 0 / 7%)" : null,
                                }}
                            />
                        </td>
                    ) : null
                }
            </tr>
        );
    }
}
